import _ from 'lodash';

window._ = _;

function InjuryDetailCtrl($rootScope, $scope, $stateParams, $timeout, $ngConfirm, toastr, AuthService, AnalysisService, PlayerService, AppContextService, UserService, DashboardService, PlanService) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;

  var userInfo = function () {
    var data = {
      'user_id': $stateParams.user_id,
    }
    UserService.info(data).then(function (res) {
      // console.log(res.data);
      vm.info = res.data;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

  }
  userInfo();

  vm.player = _.find(vm.appContext.players.all, { user_id: $stateParams.user_id });
  vm.date = new Date().toISOString().split("T")[0].split("-").join(".");
  var setInjuryData = {};

  var getInjuryMeta = function () {
    var getInjuryData = {};
    getInjuryData.login_id = vm.appContext.user.login_id;
    getInjuryData.uuid = vm.appContext.user.uuid;
    AnalysisService.getInjury(getInjuryData).then(function (res) {
      var data = res.data;
      vm.metaData = {};
      vm.metaData.states = data.states;
      vm.metaData.state = vm.metaData.states[0];

      vm.metaData.causes = data.causes;
      vm.metaData.cause = vm.metaData.causes[0];

      vm.metaData.parts = data.parts;
      vm.metaData.part = vm.metaData.parts[0];

      vm.metaData.cats = data.cats;
      vm.metaData.cat = vm.metaData.cats[0];

      vm.metaData.locations = data.locations;
      vm.metaData.location = vm.metaData.locations[0];

      vm.metaData.movements = data.movements;
      vm.metaData.movement = vm.metaData.movements[0];

    }).catch(function (e) {
      console.log('ERROR', e);
    });
  }
  getInjuryMeta();

  var getPlayerInjuryInfo = function (from, to) {
    var getInjuryData = {};
    getInjuryData.login_id = vm.appContext.user.login_id;
    getInjuryData.uuid = vm.appContext.user.uuid;
    getInjuryData.user_id = $stateParams.user_id;

    if (from && to) {
      getInjuryData.from = from;
      getInjuryData.to = to;
    }

    AnalysisService.getInjury(getInjuryData).then(function (res) {
      var data = res.data;
      vm.playerInjuryRecord = data.data;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };
  getPlayerInjuryInfo();

  vm.getPlayerInjuryInfo = getPlayerInjuryInfo;

  var getPlayerDateInjuryInfo = function (date, id) {
    var getInjuryData = {};
    getInjuryData.login_id = vm.appContext.user.login_id;
    getInjuryData.uuid = vm.appContext.user.uuid;
    getInjuryData.user_id = $stateParams.user_id;
    getInjuryData.date = date;
    AnalysisService.getInjury(getInjuryData).then(function (res) {
      if (res.data.data.length) {
        var injuryInfo = _.find(res.data.data, {
          id: id
        });

        vm.metaData.state = _.find(vm.metaData.states, {
          id: injuryInfo.state_id
        });
        vm.metaData.cause =  _.find(vm.metaData.causes, {
          id: injuryInfo.cause_id
        });
        vm.metaData.movement =  _.find(vm.metaData.movements, {
          id: injuryInfo.movement_id
        });
        vm.metaData.part =  _.find(vm.metaData.parts, {
          id: injuryInfo.part_id
        });
        vm.metaData.cat =  _.find(vm.metaData.cats, {
          id: injuryInfo.cat_id
        });
        vm.metaData.location =  _.find(vm.metaData.locations, {
          id: injuryInfo.location_id
        });
      } else {
        $timeout(function() {
          vm.metaData.state = vm.metaData.states[0];
          vm.metaData.cause = vm.metaData.causes[0];
          vm.metaData.part = vm.metaData.parts[0];
          vm.metaData.cat = vm.metaData.cats[0];
          vm.metaData.location = vm.metaData.locations[0];
          vm.metaData.movement = vm.metaData.movements[0];
        });
      }
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };

  // 기록
  vm.record = function () {
    setInjuryData.login_id = vm.appContext.user.login_id;
    setInjuryData.uuid = vm.appContext.user.uuid;
    setInjuryData.user_id = $stateParams.user_id;
    setInjuryData.date = vm.date;

    var check = (setInjuryData.state_id && setInjuryData.cause_id && setInjuryData.part_id && setInjuryData.cat_id && setInjuryData.location_id && setInjuryData.movement_id)
    // if (!check) {
    //   toastr.error('든 부상정보를 선택해주십시오');
    //   return;
    // }

    console.log()

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      user_id: $stateParams.user_id,
      date: vm.date,
      state_id: vm.metaData.state.id,
      cause_id: vm.metaData.cause.id,
      part_id: vm.metaData.part.id,
      cat_id: vm.metaData.cat.id,
      location_id: vm.metaData.location.id,
      movement_id: vm.metaData.movement.id,
      comment: vm.comment
    }

    AnalysisService.setInjury(data).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        toastr.success('저장되었습니다.');
        getPlayerInjuryInfo();
      } else {
        toastr.error('오류가 발생하였습니다.');
      }
    });
  };

  // 삭제
  vm.removeInjury = function (id) {
    var removeInjuryData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      injury_id: id
    };

    AnalysisService.removeInjury(removeInjuryData).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        toastr.success('부상정보가 삭제되었습니다.');
        getPlayerInjuryInfo();
      } else {
        toastr.error('부상정보 삭제중 오류가 발생하였습니다.');
      }
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };


  /**
   * select 변경시 값 적용
   */
  // 부상 상태 변경

  // $scope.$watch('injuryDetail.metaData.state', function (newVal, oldVal) {
  //   if (newVal) {
  //     setInjuryData.state_id = newVal.id;
  //   }
  // });

  // // 부상 구분 변경
  // $scope.$watch('injuryDetail.metaData.cause', function (newVal, oldVal) {
  //   // alert('aaa')
  //   if (newVal) {
  //     setInjuryData.cause_id = newVal.id;
  //   }
  // });

  // // 부상 부위 변경
  // $scope.$watch('injuryDetail.metaData.part', function (newVal, oldVal) {
  //   if (newVal) {
  //     setInjuryData.part_id = newVal.id;
  //   }
  // });

  // // 부상 종류 변경
  // $scope.$watch('injuryDetail.metaData.cat', function (newVal, oldVal) {
  //   if (newVal) {
  //     setInjuryData.cat_id = newVal.id;
  //   }
  // });

  // // 부상 위치 변경
  // $scope.$watch('injuryDetail.metaData.location', function (newVal, oldVal) {
  //   if (newVal) {
  //     setInjuryData.location_id = newVal.id;
  //   }
  // });

  // // 부상 상황 변경
  // $scope.$watch('injuryDetail.metaData.movement', function (newVal, oldVal) {
  //   if (newVal) {
  //     setInjuryData.movement_id = newVal.id;
  //   }
  // });

  //$scope.$watch('vm.date', function(newVal, oldVal) {
  //  getPlayerDateInjuryInfo(newVal);
  //});

  vm.selectedInjuryId = null;
  vm.updateInjuryInfo = function(item) {
    getPlayerDateInjuryInfo(item.date, item.id);
  };


  vm.video = {
    title: '',
    url: ''
  };

  vm.content = {
    title: '',
    subtitle: '허리',
    type: 'url',
    url: ''
  };

  var list = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
    };
    DashboardService.list(data)
      .then(function (res) {
        vm.contents = res.data.lists[3].list[0].contents;
        vm.videos = res.data.lists[3].list[0].videos;
        _.forEach(vm.videos, video => {
          if (video.url.indexOf('?v=') > -1) {
            video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
          } else {
            video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
          }
        });


      })
      .catch(function (error) {
        console.log('ERROR : ', error);
      });
  }
  list();

  vm.set = function (type, is_video) {

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type,
      is_video: is_video,
      is_admin: 'N',
      title: is_video === 'Y' ? vm.video.title : vm.content.title,
      subtitle: is_video === 'Y' ? vm.video.subtitle : vm.content.subtitle,
      url: is_video === 'Y' ? vm.video.url : vm.content.url
    };

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }


    DashboardService.set(data).then(function (res) {
      list();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  }

  vm.recommendedVideos = [];

  vm.isFirstSearch = true;
  var footballArr = ['football', 'football', 'football', 'soccer', 'soccer', 'futsal']; // 검색결과가 다양하게 나오게 하기 위한 처리, football, soccer 에 가중치를 줌
  
  // 영상 구분을 선택하면 영상 추천
  $scope.$watch('vm.video.subtitle', function (newVal, oldVal) {
    var container = $('#injury-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' injury ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };

      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a> <a href="#" class="select-video" style="text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  });

  // 추천영상 보기
  $('body').off('click.selectVideo').on('click.playVideo', '.play-video', function(e) {
    e.preventDefault();

    var anchor = $(this);
    document.getElementById('recommended_video').style.display = 'block';

    $scope.$apply(function () {
      vm.recommendedVideo = _.find(vm.recommendedVideos, {
        id: anchor.data('id')
      });
    });
  });

  // 추천영상 선택
  $('body').off('click.selectVideo').on('click.selectVideo', '.select-video', function(e) {
    e.preventDefault();

    var anchor = $(this);

    $scope.$apply(function () {
      vm.video.url = anchor.data('url');
      vm.video.title = anchor.data('title');
    });

    toastr.success('영상이 선택되었습니다.');
  });

  vm.remove = function (id) {
    // var data = {
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   id: id
    // };
    // DashboardService.remove(data).then(function (res) {
    //   list();
    // });


    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id
            };
            DashboardService.remove(data).then(function (res) {
              list();
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });


          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });

  }

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });


}

export default {
  name: 'InjuryDetailCtrl',
  fn: InjuryDetailCtrl
};
